export type TProgressStatus = {
  color: string
  marker: string
  tooltip: string
}

const PROGRESS_STATUS_COLOR_MAP = {
  red: '#dc2626',
  amber: '#f59e0b',
  green: '#16a34a',
  white: '#ffffff',
}
// const PROGRESS_STATUS_COLOR_MAP = {
//   red: '#ef4444',
//   amber: '#ca8a04',
//   green: '#22c55e',
//   white: '#ffffff',
// }

const PROGRESS_STATUS_MARKER_MAP = {
  // check: 'IconCircleCheckmarkOutline',
  check: 'IconV2CorrectOutline',
  cross: 'IconCircleDeleteOutline',
  // na: 'IconRightChevronCircleOutline',
  na: 'IconV2ArrowRightOutline',
  todo: 'IconCircleEmptyOutline',
}
// const PROGRESS_STATUS_MARKER_MAP = {
//   check: 'IconCheckMarkOutline',
//   cross: 'IconCloseOutline',
//   na: 'IconRightChevronOutline',
//   todo: 'IconWaitOutline',
// }

import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { cn, getContrastTextColor } from '@/lib/utils'
// import { IconMinusOutline } from '@icons/IconMinusOutline'
import { Fragment } from 'react/jsx-runtime'
import { isProgressStatusArray } from './utils'
export function ProgressStatus({ value }: { value: TProgressStatus[] }) {
  if (!isProgressStatusArray(value)) {
    return null
  }
  return (
    <div className="flex items-center">
      {value.map((item, i) => {
        const isFirst = i === 0
        const bgColor = PROGRESS_STATUS_COLOR_MAP[item.color as keyof typeof PROGRESS_STATUS_COLOR_MAP]
        const textColor = getContrastTextColor(bgColor)
        // const textColor = 'black'
        const style = {
          backgroundColor: bgColor,
          // backgroundColor: hexToHslaOrPassthrough(bgColor, 0.3),
          color: item.color === 'white' ? '#474747' : textColor,
        }
        const iconName = PROGRESS_STATUS_MARKER_MAP[item.marker as keyof typeof PROGRESS_STATUS_MARKER_MAP]
        return (
          <Fragment key={`${item.tooltip}-${i}-${item.color}-${item.marker}`}>
            {/* {!isFirst && <IconMinusOutline className="size-2 text-muted-foreground" />} */}
            {/* {!isFirst && <span className="mx-0.5">-</span>} */}
            {!isFirst && <div className="mx-[3px] h-0.5 w-[7px] bg-foreground/50"></div>}
            <TooltipButton tooltip={item.tooltip}>
              <div
                className={cn('relative size-5 overflow-hidden rounded-full', {
                  'border border-foreground/50': item.color === 'white',
                })}
                style={style}
              >
                <DynamicIcon
                  iconName={iconName}
                  className={cn('relative size-[24px] -translate-x-[2px] -translate-y-[2px]', {
                    '-translate-x-[2.75px] -translate-y-[2.75px]': item.color === 'white',
                  }, {
                    'size-[16px] translate-x-[2px] translate-y-[2px]': ['IconV2ArrowRightOutline', 'IconV2CorrectOutline'].includes(iconName),
                  }, {
                    'size-[16px] translate-x-[1.25px] translate-y-[1.25px]': ['IconV2ArrowRightOutline', 'IconV2CorrectOutline'].includes(iconName) && item.color === 'white',
                  })}
                />
              </div>
            </TooltipButton>
          </Fragment>
        )
      })}
      {/* return (
          <Fragment key={`${item.tooltip}-${i}-${item.color}-${item.marker}`}>
            {!isFirst && <IconMinusOutline className="size-2 text-muted-foreground" />}
            <TooltipButton tooltip={item.tooltip}>
              <div
                className={cn(`flex size-5 shrink-0 items-center justify-center rounded-full`, {
                  'border-2': item.color === 'white',
                })}
                style={style}
              >
                <DynamicIcon
                  iconName={PROGRESS_STATUS_MARKER_MAP[item.marker as keyof typeof PROGRESS_STATUS_MARKER_MAP]}
                  className="size-2.5"
                />
              </div>
            </TooltipButton>
          </Fragment>
        )
      })} */}
    </div>
  )
}
